import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { Tabs } from "..";
import { GuestCard } from "../../../../../components/cards/guestCard";
import { NumberCard } from "../../../../../components/cards/numberCard";
import { Icon } from "../../../../../components/icon/icon";
import { MiniHeader } from "../../../../../components/typography/miniHeader";
import { RenderMarkdown } from "../../../../../components/typography/renderMarkdown";
import { BgWrapper } from "../../../../../components/wrapper/bgWrapper";
import { useAdminGetPurchaseStatisticsQuery } from "../../../../../redux/features/admin/payments/payments.api";
import {
  CreatedEvent,
  GetEventGuestsResponse,
  GetEventTicketsResponse,
} from "../../../../../redux/features/event/event.types";

export const AdminEventOverview = ({
  event,
  setTab,
  ticketsData,
  guests,
  loading = false,
}: {
  event: CreatedEvent;
  setTab: (tab: Tabs) => void;
  ticketsData?: GetEventTicketsResponse;
  guests?: GetEventGuestsResponse;
  loading?: boolean;
}) => {
  const navigate = useNavigate();

  const { data: statistics, isFetching: fetchingStatistics } =
    useAdminGetPurchaseStatisticsQuery(
      {
        eventId: event._id,
      },
      { refetchOnMountOrArgChange: true },
    );

  return (
    <>
      <BgWrapper className="flex flex-col gap-3 !rounded-t-none">
        <div className="grid grid-cols-1 gap-[10px] md:grid-cols-3">
          <NumberCard
            value={0}
            text="Views"
            isCurrency={false}
            tooltipId={undefined}
            tooltipText={undefined}
            loading={fetchingStatistics}
          />

          <NumberCard
            value={guests?.data?.totalCount ?? 0}
            text="Guests"
            isCurrency={false}
            tooltipId={undefined}
            tooltipText={undefined}
            loading={fetchingStatistics}
          />

          <NumberCard
            value={ticketsData?.data?.totalCount ?? 0}
            text="EventTickets"
            isCurrency={false}
            tooltipId={undefined}
            tooltipText={undefined}
            loading={fetchingStatistics}
          />

          <NumberCard
            value={statistics?.data.totalTicketsSold ?? 0}
            text="Total Tickets Sold"
            isCurrency={false}
            tooltipId={"totalTicketsSold"}
            tooltipText={"The total number of tickets that have been bought."}
            loading={fetchingStatistics}
          />

          <NumberCard
            value={statistics?.data.totalSalesRevenue ?? 0}
            text="Total Sales Revenue"
            tooltipId={"totalSalesRevenue"}
            tooltipText={
              "The total amount of tickets sold which includes our fees."
            }
            loading={fetchingStatistics}
          />

          <NumberCard
            value={statistics?.data.totalAmountMade ?? 0}
            text="Total Amount Made"
            tooltipId={"totalAmountMade"}
            tooltipText={
              "You'll receive this amount in your payout account—your earnings from ticket sales after our fees have been deducted."
            }
            loading={fetchingStatistics}
          />
        </div>
      </BgWrapper>

      <BgWrapper
        className={classNames("flex flex-col gap-3")}
        loading={loading}
        loaderHeight={120}
      >
        <MiniHeader header="Description" className="!text-grey-500" />

        <div className="text-sm font-bold text-grey-900">
          <RenderMarkdown>{event?.description ?? ""}</RenderMarkdown>
        </div>
      </BgWrapper>

      <BgWrapper
        className={classNames("flex flex-col gap-3")}
        loading={loading}
        loaderHeight={80}
      >
        <MiniHeader header="Hosted By" className="!text-grey-500" />

        <div className="flex items-center justify-between gap-2 text-sm font-bold text-grey-900">
          <GuestCard
            className=""
            name={`${event?.createdBy?.firstName} ${event?.createdBy?.lastName}`}
            email={`${event?.createdBy?.email}`}
            timeAgo={undefined}
            hideEmailOnMobile={false}
            guest={undefined}
            ticketColor={undefined}
          />

          <button
            type="button"
            className="flex w-fit items-center gap-2 text-base font-bold text-grey-700"
            onClick={() => {
              navigate(`/users/${event?.createdBy?._id}`);
            }}
          >
            View
            <Icon
              svg="caret-down"
              width={20}
              height={20}
              className="-rotate-90 text-grey-400"
            />
          </button>
        </div>
      </BgWrapper>
    </>
  );
};
